import './index.css'
import { $$ } from '../../utils/utils'

const urlMap = {
  bcz: 'https://www.baicizhan.com/',
  mint: 'http://reading.baicizhan.com/',
  yequ: 'https://np.baicizhan.com/'
}

$$('.link-title').forEach(node => {
  const id = node.getAttribute('id')
  node.addEventListener('click', function() {
    window.location.href = urlMap[id]
  })
})
